// Replacement Δ helpers. NEGATIVE return value === the swap LOWERS the
// loss (improvement). Positive === regression. Null when the underlying
// loss values aren't available.
//
//   dropDelta = dropOnlyLoss - baseLoss
//   swapDelta = replacedLoss - baseLoss
//
// Sign convention chosen so "biggest improvement" sorts first under
// ascending sort.

export function dropDelta(
  baseLoss: number | null,
  dropOnlyLoss: number | null,
): number | null {
  if (baseLoss == null || dropOnlyLoss == null) return null;
  return dropOnlyLoss - baseLoss;
}

export function swapDelta(
  baseLoss: number | null,
  replacedLoss: number | null,
): number | null {
  if (baseLoss == null || replacedLoss == null) return null;
  return replacedLoss - baseLoss;
}
